onComplete(function () {
	const navHeader = document.querySelector('.nav-header');

	const updateHeaderHeight = () => {
		if (navHeader) {
			document.documentElement.style.setProperty(
				'--header-height',
				`${navHeader.offsetHeight}px`
			);
		}
	};

	if (navHeader) {
		updateHeaderHeight();

		new ResizeObserver(updateHeaderHeight).observe(navHeader);

		window.addEventListener('resize', updateHeaderHeight);
	};
});